import { Button } from "antd";
import SuccessCircleIcon from "../../assets/icons/SuccessCircleIcon";
import CustomModal from "../ui/CustomModal";

interface Props {
  title: string;
  handleClose: () => void;
  handleOkay: () => void;
  open: boolean;
  data: any;
  type?: "ADD" | "UPDATE" | "SUCCESS";
}

export default function SuccessModal({
  handleClose,
  open,
  data,
  title,
  handleOkay,
}: Props) {
  return (
    <CustomModal
      width={400}
      title=""
      open={open}
      handleClose={handleClose}
      footer={null}
    >
      <div className="flex flex-col items-center justify-center text-center space-y-4 h-full">
        <div>
          <SuccessCircleIcon />
        </div>

        <div className="font-medium text-base leading-7 tracking-[-0.3px] font-inter">
          {title}
        </div>

        <Button
          onClick={handleOkay}
          className="w-[57px] h-[36px] rounded-[6px] px-[12px] py-[6px] bg-[#FFF1EB] text-[#FE7235] flex items-center justify-center gap-[10px]"
        >
          Ok
        </Button>
      </div>
    </CustomModal>
  );
}
